import { render, staticRenderFns } from "./MtrbAddMain.vue?vue&type=template&id=53ad5352&scoped=true&"
import script from "./MtrbAddMain.vue?vue&type=script&lang=js&"
export * from "./MtrbAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MtrbAddMain.vue?vue&type=style&index=0&id=53ad5352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad5352",
  null
  
)

export default component.exports